import React, { PureComponent } from "react";
import SvgIcon from "material-ui/SvgIcon";

/** @augments {PureComponent<any, any>} */
class Eye extends PureComponent {
    render() {
        return (
            <SvgIcon {...this.props}>
                <path
                    d="M12,5C8.2,5,3.2,9.5,1.3,11.3c-0.4,0.4-0.4,1.1,0,1.5C3.2,14.5,8.2,19,12,19s8.8-4.5,10.7-6.3c0.4-0.4,0.4-1.1,0-1.5
    C20.8,9.5,15.8,5,12,5z M12,16c-2.1,0-3.8-1.8-3.8-4S9.9,8,12,8s3.8,1.8,3.8,4S14.1,16,12,16z"
                />
            </SvgIcon>
        );
    }
}

export default Eye;
